var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406 203C406 91 316 0 203 0 139 0 82 30 45 76l39 10c4 1 8 5 8 8l9 31c2 7-2 14-9 16s-13-3-16-9l-6-24-40-10C11 129 0 165 0 203c0 113 91 203 203 203 113 0 203-90 203-203zm-293 61c-2-6 2-13 8-15 8-2 14 2 16 8l1 2 111 12 12-37H114c-6 0-11-3-12-9l-16-61c-2-7 2-13 9-15h1l201-33c7-1 14 3 14 10 1 3 1 5 0 6l-9 36c-2 6-10 10-16 8-7-2-10-8-9-15l4-17-167 27 9 38h154c2 0 3 0 4 1 7 2 11 8 9 16l-20 63c-1 5-6 9-13 8l-130-14c-6 0-9-3-11-9l-3-10zm133 60c0-10-8-19-18-19-11 0-19 9-19 19s8 20 19 20c10 0 18-10 18-20zm-78-8c0-11-8-20-18-20-11 0-19 9-19 20 0 10 8 18 19 18 10 0 18-8 18-18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.9fbf571215c821162cb973e4505f1a7e.svg";
export { ForwardRef as ReactComponent };